var React = require('react');

function Blob2 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M437.75 555.03c10.72 65.25 113.44 90.72 147.28 28.4 28.1-51.85-23.5-97.37-70.63-107.69-60.15-13.07-85.62 24.79-76.65 79.29z","key":0}),React.createElement("path",{"d":"M931.14 245.87c35.9 86.14 6.25 203.36-83.57 241.2-75.1 31.6-161.64-4.54-226.9-42.8-45-26.43-93-58.88-144.68-50.63-31.78 5.07-58.79 24.94-85.8 42.49-31.56 20.4-65.67 38.36-102.74 43.97-73.2 10.99-145.12-28.33-199.98-77.8-67.69-60.88-108.9-157.91-75.85-246.8C71.15-4.85 298.57-19.22 437.86 15.87c73.61 18.6 131.24 60.46 197.44 94.92 56.03 29.28 114.92 36.25 175.62 49.25 52.43 11.2 98.5 33.93 120.22 85.83zM987.32 115.67c-23.26-38.14-93.1-23.3-98.05 26.43-4.09 41.36 39.33 54.66 71.03 46.98 40.43-9.86 46.47-41.55 27.02-73.4z","key":1})]);
}

Blob2.defaultProps = {"width":"100%","fill":"none","viewBox":"0 0 998 620"};

module.exports = Blob2;

Blob2.default = Blob2;
